<template>
  <div class="page-login">
    <div class="page-container" :style="isLoginDialog?'padding-bottom: 50px;':''">
      <div class="page-header" v-if="!isLoginDialog">
        <div>
          <img src="../../assets/logo_tm.png">
        </div>
        <div class="page-headerRight">
          <div>{{ $t("global.title1")}} </div>
          <div>{{ $t("global.title2")}} </div>
        </div>
      </div>

      <div class="page-main" :style="isLoginDialog?'text-align: center;':''">
        <div class="cover" v-if="!isLoginDialog">
          <img src="../../assets/loginLeft.png" style="width:410px;">
        </div>
        <div :style="isLoginDialog?'':'margin-left:170px;'">
          <el-card class="login-card">
            <div class="lang-title">
              <div class="form-title">{{ $t("login.login") }}</div>
              <div class="header-language">
                <lang-switcher />
              </div>
            </div>
            <el-form ref="loginForm" :model="loginFormModel" size="large" style="padding:0 40px;">
              <template>
                <el-form-item prop="account">
                  <el-input
                    :class="{'iconInput':emailInputFocus}"
                    v-model="loginFormModel.account"
                    :placeholder="$t('queryForm.companyEmail')"
                    prefix-icon="el-icon-ali-emial"
                    @focus="emailInputFocus = true"
                    @blur="emailInputFocus = false"
                  />
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    :class="{'iconInput':pwdInputFocus}"
                    v-model="loginFormModel.password"
                    type="password"
                    :placeholder="$t('administration.paw')"
                    prefix-icon="el-icon-ali-fenzu"
                    autocomplete="off"
                    @focus="pwdInputFocus = true"
                    @blur="pwdInputFocus = false"
                  />
                </el-form-item>
                <el-form-item prop="captcha">
                  <div class="captcha-wrap">
                    <div class="captcha-left">
                      <el-input v-model="loginFormModel.captcha" :placeholder="$t('administration.verificationCode')" />
                    </div>
                    <!-- <div class="captcha-right" /> -->
                    <!-- <div class="code" @click="refreshCode">
                      <identify :identify-code="identifyCode" />
                    </div>-->
                    <div class="securitycode-right">
                      <el-button v-show="show" :loading='isloading' style="width:120px;margin-left: 16px;" @click="userCode">{{ $t('administration.getCode') }}</el-button>
                      <el-button v-show="!show" style="width:120px;margin-left: 16px;" >{{count}} s</el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item>
                  <span style="float:left;">
                    <el-checkbox v-model="checked">{{ $t('administration.automaticLogin') }}</el-checkbox>
                  </span>
                  <!-- <span style="float:right;">
                    <el-button type="text" @click="toggleLoginType"
                      >使用手机号码登录</el-button
                    >
                  </span>-->
                </el-form-item>
              </template>
              <!-- <template v-else>
                <el-form-item prop="mobile">
                  <el-input
                    v-model="loginFormModel.mobile"
                    placeholder="请输入手机号码"
                    prefix-icon="el-icon-user"
                  />
                </el-form-item>
                <el-form-item prop="securitycode">
                  <div class="securitycode-wrap">
                    <div class="securitycode-left">
                      <el-input
                        v-model="loginFormModel.securitycode"
                        placeholder="请输入验证码"
                        maxlength="4"
                        prefix-icon="el-icon-unlock"
                        autocomplete="off"
                      />
                    </div>
                    <div class="securitycode-right">
                      <el-button style="width:120px;">获取验证码</el-button>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item>
                  <span style="float:right;">
                    <el-button type="text" @click="toggleLoginType"
                      >使用账号密码登录</el-button
                    >
                  </span>
                </el-form-item>
              </template>-->
              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  class="login-button"
                  style="width:100%;"
                  :loading="isLoading"
                  @click="login()"
                >{{ $t("login.login") }}</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {LoadMenuAndRoutes} from '@/views/layout/nav'
// import identify from '../components/identify'
import { MessageBox, Message } from 'element-ui'
import { userLogin, userGetCode } from '../../api/login'

export default {
  components: {},
  props: {
    isLoginDialog: {//是否登录模态框
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否获取焦点
      emailInputFocus:false,
      pwdInputFocus:false,
      // 验证码
      identifyCodes: '1234567890',
      identifyCode: '',
      // 验证码
      isLoading: false,
      loginFormModel: {
        account: '',
        password: '',
        // mobile: '',
        // securitycode: '',
        captcha: ''
      },
      checked: false,
      loginFormRule: {
        mobile: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        securitycode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      show: true,
      count: '',
      timer: null,
      isloading:false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.identifyCode = ''
    // if (localStorage.getItem('userName') && localStorage.getItem('userPw')) {
    //   this.loginFormModel.account = localStorage.getItem('userName')
    //   this.loginFormModel.password = localStorage.getItem('userPw')
    //   this.checked = true
    // }
    // this.makeCode(this.identifyCodes, 4)
  },
  methods: { 
    // 获取动态码
    userCode() {
      this.isloading = true
      if (this.loginFormModel.account === '') {
        Message({
          message: this.$t("administration.Companymailbox"),
          type: 'error',
          duration: 5 * 1000
        })
        this.isloading = false
        return
      }else{
        let myreg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        if (!myreg.test(this.loginFormModel.account)) {
          Message({
            message: this.$t("administration.Incorrectmailboxformat"),
            type: 'error',
            duration: 5 * 1000
          })
          this.isloading = false
          return
        }
      }
      const self = this
      const param = {
        username: self.loginFormModel.account
      }
      userGetCode(param).then(response => {
        // debugger
        if (response.code == 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.isloading = false
          const TIME_COUNT = 120;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
              }
            }, 1000)
          }
        }else{
          this.isloading = false
        }
      })
    },

    login() {
      if (this.loginFormModel.account === '') {
        Message({
          message: this.$t("administration.usermailboxempty"),
          type: 'error',
          duration: 5 * 1000
        })
        return
      } else if (this.loginFormModel.password === '') {
        Message({
          message: this.$t("administration.pawnot"),
          type: 'error',
          duration: 5 * 1000
        })
        return
      }
       else if (this.loginFormModel.captcha === "") {
        Message({
          message: this.$t("administration.codenot"),
          type: "error",
          duration: 5 * 1000
        });
        return;
      }
      else {
        // 验证成功，开始登录
        const self = this
        const param = {
          username: self.loginFormModel.account,
          password: self.loginFormModel.password,
          code: self.loginFormModel.captcha,
          checklistStatus: self.checked ? '1' : '0'
        }
        userLogin(param).then(response => {
          // debugger
          if (response.code == 200) {
            //console.log(self.checked)
            // if (self.checked) {
            //   localStorage.setItem("userName", self.loginFormModel.account);
            //   localStorage.setItem("userPw", self.loginFormModel.password);
            // } else {
            //   localStorage.removeItem("userName");
            //   localStorage.removeItem("userPw");
            // }
            //console.log(response.data)
            this.$store.commit('setUserInfo', response.data)

            // localStorage.setItem("userData", JSON.stringify(response.data));
            if(this.isLoginDialog && window.layoutObj){
              //是否登录模态框
              window.layoutObj.closeLoginDialog()
              // if(window.isRouteChange){
              //   window.isRouteChange = false
              //   // this.$router.go(0)
              //   window.location.reload()
              // }
            }
            else{
              self.$router.push({
                // path: '/home/index'
                name: 'welcome',
                params: {isLogin: true}
              })
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-login {
  height: 100%;
  -webkit-user-select: none;
  box-sizing: border-box;
  background: url("../../assets/loginBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 600px;
  min-width: 1000px;

  .page-container {
    /* min-width: 1000px; */
    width: 1043px;
    /* background-color: rgba(40, 40, 40, 0.2); */
  }
}

.page-header {
  display: flex;
  justify-content: flex-start;
  img {
    width: 60px;
    height: 78px;
  }
  .page-headerRight {
    font-size: 24px;
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    width: 344px;
    margin-left: 30px;

    div{
      width:100%;
    }
  }
}

.extra-link {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  li {
    list-style: none;
    font-size: 18px;
    font-family: Helvetica;
    margin-left: 40px;
    display: inline-block;

    a {
      color: white;
      text-decoration: none;
    }
  }
}

.page-main {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lang-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
}
.form-title {
  font-family: "PingFang SC";
  font-weight: bold;
  font-size: 38px;
  color: #333333;
  letter-spacing: 3px;
  /* text-align: center; */
  padding: 20px 0 35px 0;
}

.login-card {
  width: 460px;
  height: 440px;
}

/*验证码*/
.captcha-wrap {
  display: flex;

  .captcha-left {
    flex: 1;
  }

  .captcha-right {
    width: 100px;
    margin-left: 10px;
    background-color: #cccccc;
    border-radius: 4px;
  }
}

/*手机验证码*/
.securitycode-wrap {
  display: flex;

  .securitycode-left {
    flex: 1;
  }

  .securitycode-right {
    // width: 150px;
    margin-left: 10px;
  }
}

.code {
  /* margin: 400px auto; */
  width: 114px;
  height: 40px;
  border: 1px solid red;
  margin-left: 19px;
}
.el-button--primary {
  background-color: #5a7ef9 !important;
  border-color: #5a7ef9 !important;
  border-radius: 22px;
  font-weight: bold;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #5a7ef9 !important;
}
/* .el-button--text{
  color: #5A7EF9!important;
} */
.el-checkbox__label {
  color: #5a7ef9 !important;
}
.page-login .page-container {
  padding-bottom: 80px;
}

.login-button{
  background:linear-gradient(135deg,rgba(6,174,240,1) 0%,rgba(1,128,227,1) 100%);
  border:0;
  box-shadow: 0 10px 20px #0676ff52;
}



</style>

<style lang="scss">
.iconInput{
  .el-input__prefix{
    .el-input__icon{
      color:#008AE3;
    }
  }
}
</style>
